import React, {useContext} from 'react';

const ConnectionContext = React.createContext();

export const useConnectionContext = () => useContext(ConnectionContext);

export default ConnectionContext;
